import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';

import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';

import {EntryStore} from '@stores/entry.store';
import {
  CacheExpirationEvent,
  CacheExpirationStrategyService,
} from '@services/cache-expiration-strategy.service';
import {EventTrackingStore} from '@stores/event-tracking.store';

import {Action} from './action';
import {isEntryChange} from '@utils/event-utils';
import {
  Action as AdvanceAction,
  AdvanceWithActionTransformer,
} from '@stores/entry-store-transformers/advance-with-action.transformer';

@Injectable()
export class ReceiveEventAcknowledgementAction implements Action<
  string,
  boolean
> {
  constructor(
    private entryStore: EntryStore,
    private cacheExpirationStrategy: CacheExpirationStrategyService,
    private eventTrackingStore: EventTrackingStore,
    private advanceWithActionTransformer: AdvanceWithActionTransformer,
  ) {}

  execute(trackingId: string): Observable<boolean> {
    const activeEvent = this.eventTrackingStore.state()[trackingId];
    if (U.isEmpty(activeEvent)) {
      return of(void 0);
    }

    const payload = (activeEvent.outbound?.c ??
      []) as PL2.AnyPartialEntryWithId[];
    if (U.isEmpty(payload)) {
      return of(true);
    }

    const intent = activeEvent.event?.int;
    if (U.isEmpty(intent) || !isEntryChange(intent)) {
      return of(true);
    }

    this.cacheExpirationStrategy.deepExpire(
      CacheExpirationEvent.Success,
      this.entryStore,
    );

    this.entryStore.modifyStateWithTransformer(
      {
        payload: payload,
        action: AdvanceAction.Sent,
        intent: intent,
      },
      this.advanceWithActionTransformer,
    );

    return of(true);
  }
}
